import React, { memo } from "react";
import { AlarmListNode } from "../alarm-list-node/alarm-list-node";
import styles from "./alarm-list-table.module.scss";
import { AlarmRow } from "@src/cloud-connect/alarms/entities/alarm-row";
import { v4 as uuidv4 } from "uuid";

const cssClassName = "alarm-list-table";

interface AlarmListTablePropTypes {
  arrayOfAlarmRows: AlarmRow[];
}

export const AlarmListTable = memo(
  ({ arrayOfAlarmRows }: AlarmListTablePropTypes) => {
    return (
      <ul className={styles[cssClassName]}>
        {arrayOfAlarmRows.map((rowElement, index) => {
          return (
            <AlarmListNode
              key={uuidv4()}
              node={rowElement.getAlarm().getOurNode()}
              alarmRow={rowElement}
              index={index}
              length={arrayOfAlarmRows.length}
            />
          );
        })}
      </ul>
    );
  },
);

AlarmListTable.displayName = "AlarmListTable";
